import { render, staticRenderFns } from "./LabCard.vue?vue&type=template&id=a1c38af0&"
import script from "./LabCard.vue?vue&type=script&lang=js&"
export * from "./LabCard.vue?vue&type=script&lang=js&"
import style0 from "./LabCard.vue?vue&type=style&index=0&id=a1c38af0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports